import { useChatSidebarStore } from '@air/feature-ag-ui-chat';

import { CHAT_SIDEBAR_WIDTH_CSS_VAR } from '../constants';
import { useEditCanvasStore } from '../store';

export type VisiblePaneScreenSize = { height: number; width: number };

/** Full `.react-flow` pane size — pair with `getFitViewPadding` for fit math (chat inset is padding, not width). */
export const getReactFlowPaneScreenSize = (): VisiblePaneScreenSize | undefined => {
  const container = document.querySelector('.react-flow');

  if (!container) {
    return undefined;
  }

  const rect = container.getBoundingClientRect();

  if (rect.width <= 0 || rect.height <= 0) {
    return undefined;
  }

  return { height: rect.height, width: rect.width };
};

/**
 * Returns the visible `.react-flow` pane size in screen pixels, accounting for
 * the floating chat sidebar when open. Use for overlap/visibility math only —
 * not for `computeFitViewport` (that path uses `getReactFlowPaneScreenSize` +
 * `getFitViewPadding`).
 */
export const getVisibleReactFlowPaneScreenSize = (): VisiblePaneScreenSize | undefined => {
  const container = document.querySelector('.react-flow');

  if (!container) {
    return undefined;
  }

  const rect = container.getBoundingClientRect();

  let rightInset = 0;

  if (!useEditCanvasStore.getState().isFullscreen && useChatSidebarStore.getState().open) {
    const chatWidth = document.documentElement.style.getPropertyValue(CHAT_SIDEBAR_WIDTH_CSS_VAR);

    if (chatWidth) {
      rightInset = parseInt(chatWidth, 10);
    }
  }

  const width = rect.width - rightInset;
  const height = rect.height;

  if (width <= 0 || height <= 0) {
    return undefined;
  }

  return { height, width };
};
